import { displayUnitSymbol } from '../constants/units'
import type { ConfiguratorPropertyType, Unit } from '../enums'

import { formatNumber } from './format-number'

type PropertyValueLike = {
  type: ConfiguratorPropertyType
  textValue: string | null
  numberValue: number | null
  unit: Unit | null
  /**
   * How many places the figure is written to, where the thing it came from
   * says. A product property declares one and its input renders it; a free-text
   * spec declares none and takes whatever the figure carries.
   */
  decimalPlaces?: number
}

export function hasPropertyValue(prop: PropertyValueLike): boolean {
  return prop.textValue !== null || prop.numberValue !== null
}

export function formatPropertyValue(prop: PropertyValueLike): string | null {
  if (prop.type === 'NUMBER') {
    if (prop.numberValue === null) return null
    const formatted = formatNumber(
      prop.numberValue,
      prop.decimalPlaces === undefined
        ? undefined
        : {
            minimumFractionDigits: prop.decimalPlaces,
            maximumFractionDigits: prop.decimalPlaces,
          },
    )
    const symbol = displayUnitSymbol(prop.unit)
    return symbol ? `${formatted} ${symbol}` : formatted
  }
  return prop.textValue
}
